<template>
<v-container fluid grid-list-md style="padding: 20px;">
  <v-row   v-if="!addQuest">
  <!-- TABLE INSERE QUESTIONARIOS -->
  <v-col cols="12" sm="12" md="12">
  <v-data-table
    :search="search"
    :headers="headerDisp"
    :items="dispositivos"
    sort-by="titulo"
    class="elevation-1"
    style="border-radius: 10px;"
  >
    <template v-slot:top>
      <v-toolbar flat color="white" style="border-radius: 10px;">
        <v-toolbar-title class="textoUser">DISPOSITIVOS        
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Procurar"
            single-line
            hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
<!--         <v-btn text @click="addQuest=true" tile color="#00253E" >
            <v-icon left dark>add_circle</v-icon> Adicionar novo
        </v-btn> -->
      </v-toolbar>
    </template>
  <template v-slot:item.ativo="{ item }">
    <td class="text-xs-center">
      <v-icon color="success" v-if="item.ativo">brightness_1</v-icon>
      <v-icon color="error" v-else>brightness_1</v-icon>
    </td>
  </template>
    <template v-slot:item.action="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
        <v-icon
          v-on="on"
          large
          class="mr-2"
          @click="editItem(item)"
          color="#01579B"
        >
          input
        </v-icon>
    </template>
    <span>Associar Pesquisa</span>
    </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="#94AAB4" @click="carregaDados">Recarregar</v-btn>
    </template>
  </v-data-table>
  </v-col>
  </v-row>

  <v-row v-if="addQuest">
  <v-col cols="12" sm="12" md="12">
<v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Associar Pesquisa</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-row>
            <v-col cols="12" sm="6" md="6">
            <v-text-field disabled v-model="dispositivo.descricao"  outlined label="Descrição" color="#94AAB4"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="12" md="6">
            <v-select
                outlined
                v-model="dispositivo.questionarioId"
                :items="questionarios"
                item-text="titulo"
                item-value="id"
                label="Pesquisa"
            ></v-select>
            </v-col>
      
<!--     <v-col cols="12" sm="12" md="6">
            <v-switch
            v-model="dispositivo.ativo"
            :label="`Ativo`"
            color="#00253E"
            ></v-switch>
            </v-col> -->
        </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            style="border-radius: 8px;"
                            
            dark
            color="#424f4e"
            @click="salvarDisp()"
            >Salvar
        </v-btn>

        <v-btn
            style="border-radius: 8px;"
                            
            dark
            color="#D32F2F"
            @click="addQuest=false"
        >Cancelar</v-btn>
      </v-card-actions>
        </v-card>
        </v-container> 
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
 </v-col>
  </v-row>
    

    <Snackbar ref=chamaSnackbar />
</v-container>
</template>
<script>
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'
  export default {
    components: {Snackbar},
    data: () => ({    
      e1: 1,
      search:'',
      addQuest: false,
      headerDisp: [
        {
          text: 'Descrição',
          align: 'start',
          value: 'descricao',
        },
        { text: 'Pesquisa', value: 'questionario' },
        { text: 'Status', value: 'ativo' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      dispositivos: [],
      questionarios: [],
      idDispositivo: '',
      editedIndex: -1,
      editedIndexPerg: -1,
      dispositivo: {
        descricao: '',
        questionario: '',
        questionarioId: '',
        empresaId:''
      },
      defaultDisp: {
        descricao: '',
        questionario: '',
        questionarioId: '',
        empresaId:''
      },    
    }),

    computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,     
    }),

    mounted() {
      this.carregaDados()
    },

    methods: {
     async carregaDados () {
        await axios.get(`${baseApiUrl}Dispositivos?filter[where][empresaId]=${this.companyobj.id}&filter[include]=questionario&access_token=${sessionStorage.getItem('accToken')}`)
                .then(res => {
                    this.dispositivos = []
                    for (var key in res.data) {
                    if (res.data.hasOwnProperty(key)) {
                        this.dispositivos.push({
                        'descricao': res.data[key].descricao,
                        'ativo': res.data[key].ativo,
                        'mac': res.data[key].mac,
                        'questionarioId': res.data[key].questionario.id,
                        'questionario': res.data[key].questionario.titulo,
                        'empresaId': res.data[key].empresaId,
                        'id': res.data[key].id,
                            });
                        }
                      }
                    })

        await axios.get(`${baseApiUrl}Questionarios?filter[where][empresaId]=${this.companyobj.id}&access_token=${sessionStorage.getItem('accToken')}`)
                .then(res => {
                    this.questionarios = res.data
                    })
      },

      editItem (item) {
        this.editedIndex = this.dispositivos.indexOf(item)
        this.idDispositivo = item.id
        this.dispositivo = Object.assign({}, item)
        this.addQuest = true
      },

      async salvarDisp()
      {
        axios.patch(`${baseApiUrl}Dispositivos/${this.idDispositivo}?access_token=${sessionStorage.getItem('accToken')}`, this.dispositivo)
          .then(res => {        
            if(res.data != null){     
                this.carregaDados()
                this.addQuest = false              
            }           	
            }).catch(() => {
                var vm = this;          
                vm.$refs.chamaSnackbar.snack("#FEC8C8","Erro ao realizar operação","#BF4554")
            })
      },      
    },
  }
</script>
<style>
    .textoUser{
        font-weight: bold;
        color: #424f4e;
        font-size: 17px;
    }
    @font-face {
     font-family: Roboto;
     src: url('https://fonts.google.com/specimen/Roboto');
    }
    .cssBotao{
        font-weight: bold;
        border-radius: 8px; width: 150px;
        font-size: 7px;
    }
    .theme--light.v-data-table thead tr th{
      color: white;
    }
    
    span.v-stepper__step__step.primary{
    background-color: #009B99!important;
    border-color: #009b9b!important;
    }

    .theme--light.v-stepper .v-stepper__label {
        color: #009B99;
    }
    .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
        color: #009B99;
    }
</style>